// @flow

import BodyText from './body-text'

export default BodyText
